<template>
  <div
    class="tei-tiling-flow-field"
    :tabindex="ariaFlowField.tabindex"
    :aria-label="ariaFlowField.ariaLabel"
  >
    <Draggable
      class="tei-tiling-flow-field__drop-zone"
      :disabled="!interactive"
      drag-class="tei-tiling-term--dragging"
      :force-fallback="true"
      ghost-class="tei-tiling-term--ghost"
      :group="{
        name: 'tiling-tei',
        put: !selectedTerm,
      }"
      item-key="id"
      :list="draggableList"
      @change="$emit('change', column.id, $event)"
      @start="$emit('start', $event)"
      @end="$emit('end', $event)"
    >
      <template #header>
        <TEITilingTerm
          v-if="column.includesFloatingTerm && !selectedTerm"
          class="tei-tiling-term--ghost"
          layout="flow"
          :term="{}"
        />
      </template>
      <template #item>
        <TEITilingTerm
          v-if="selectedTerm"
          :disabled="!interactive"
          element="div"
          :term="selectedTerm"
          :data-term-id="selectedTerm.id"
          is-in-column
          layout="flow"
          :state="selectedTerm.state"
          @remove-term="$emit('remove-term', column.id, selectedTerm.id)"
          @arrow-key="$emit('arrow-key', $event = null, selectedTerm, column)"
        />
      </template>
    </Draggable>
    <DropIcon class="tei-tiling-flow-field__drop-icon" />
  </div>
</template>

<script>
import Draggable from 'vuedraggable';
import TEITilingTerm from '@/components/teis/TEITilingTerm.vue';
import DropIcon from '@/components/ui-elements/texas-icons/DropIcon.vue';

export default {
  name: 'TEITilingFlowField',
  components: {
    Draggable,
    DropIcon,
    TEITilingTerm,
  },
  props: {
    column: {
      type: Object,
      required: true,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'arrow-key',
    'change',
    'end',
    'remove-term',
    'start',
  ],
  computed: {
    draggableList() {
      if (this.selectedTerm) return [this.selectedTerm];

      return [];
    },
    selectedTerm() {
      // Only one term is accepted in flow fields
      return this.column.responses?.[0];
    },
    ariaFlowField() {
      if (!this.selectedTerm) {
        return { ariaLabel: this.$t('blank'), tabindex: 0 };
      }
      return { ariaLabel: '', tabindex: -1 };
    },
  },
};
</script>

<style lang="stylus">
.tei-answerfield-holder {
  display: inline-block;
}

.tei-tiling-flow-field {
  background-color: var(--tei-button-primary-disabled-color);
  border-radius: $nebula-border-radius-large;
  display: inline-block;
  height: 55px;
  position: relative;
  vertical-align: middle;
  width: 204px;

  &__drop-zone {
    height: 100%; // make sure we can drop terms anywhere in the bounds
  }

  &__drop-icon {
    fill: $nebula-color-white;
    height: $nebula-space-3x;
    pointer-events: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: $nebula-space-3x;

    .tei-tiling-flow-field__drop-zone:not(:empty) + & {
      display: none;
    }
  }

  .tei-tiling-term--ghost {
    .tei-tiling-term__inner-wrap,
    .tei-tiling-term__check-icon-wrapper {
      // Using opacity to hide these instead of display: none, so
      // that .tei-tiling-term__inner-wrap can still be used in
      // the drag height calculations in TilingTEI
      opacity: 0;
    }

    .tei-tiling-term__ghost {
      display: flex;
    }
  }
}
</style>
